module.exports = __webpack_public_path__ + "img/SLIDERS.2f60406e.svg";